import React, { useEffect, useState } from 'react'
import { MyContainer } from '../common'
import { Link } from 'react-router-dom';
import ShareButton from './ShareButton';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`navbar z-[100] bg-[#095393] sticky top-0 ${isScrolled ? '' : ''}`}>
      <MyContainer>
        <div className="flex w-full flex-1 justify-between items-center">
          <Link to="https://www.pdamcilegon.co.id/" className="flex flex-1 flex-row items-center gap-2">
            <img src={`${process.env.PUBLIC_URL}/assets/img/ic_launcher-web-round.png`} className="w-[50px] md:w-[60px]" alt="logo" />
            <div className="flex flex-col">
              <span className="text-white text-base md:text-lg font-medium">Perumda Air Minum Cilegon Mandiri</span>
              <span className="text-white text-xs md:text-sm font-normal">Kota Cilegon</span>
            </div>
          </Link>

          {/* Desktop */}
          <div className="hidden md:flex items-center gap-1">
            <div className="dropdown">
              <div tabIndex={0} role="button" className="btn btn-ghost text-white">
                Info Pelanggan
              </div>
              <ul
                tabIndex={0}
                className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow">
                <li><Link to="info-tagihan">Info Tagihan</Link></li>
              </ul>
            </div>
            <ShareButton />
          </div>

          {/* Mobile */}
          <div className="flex flex-1 justify-end md:hidden items-center gap-1">
            <ShareButton />
            <label htmlFor="my-drawer" className="btn btn-ghost drawer-button text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </label>
          </div>
        </div>
      </MyContainer>
    </div>
  )
}

export default Navbar
